export function recordToMap<K extends string | number | symbol, V>(record: Record<K, V>): Map<K, V> {
	const map = new Map<K, V>()
	for (const key in record) {
		map.set(key, record[key])
	}
	return map
}
